import styled from "styled-components";
import { MaterialIcon } from "../shared/MaterialIcon";

export const Checkbox = ({isChecked, onChange}) => {
    
    return (
        <StyledCheckbox>
            <MaterialIcon name='check' weight={400}/>
            <input
                hidden
                type="checkbox"
                checked={isChecked}
                onChange={(e) => {onChange?.(e.target.checked)}}
            />
        </StyledCheckbox>
    )
}

const StyledCheckbox = styled.label`
    display: block;
    border: 1px solid ${({theme}) => theme.colors.mutedForeground};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${({theme}) => theme.cornerRadius.sm};
    height: 18px;
    width: 18px;
    transition-duration: 110ms;
    cursor: pointer;

    &:hover
    {
        border: 1px solid ${({theme}) => theme.colors.neutralSecondaryForeground}; 

        .icon
        {
            opacity: 0.75;
        }
    }

    &:has(input:checked)
    {
        border: 1px solid ${({theme}) => theme.colors.neutralPrimaryForeground}; 

        .icon
        {
            color: ${({theme}) => theme.colors.neutralPrimaryForeground}; 
            opacity: 1;
        }
    }

    .icon
    {
        color: ${({theme}) => theme.colors.mutedForeground};
        
        opacity: 0;
        transition-duration: 110ms;
    }
`